// Global
import { Text, TextField } from '@sitecore-content-sdk/nextjs';
import React, { JSX } from 'react';

//Local
import useIsEditing from 'lib/hooks/useIsEditing';
import { useFieldWithFallbacks } from 'lib/hooks/useFieldWithFallbacks';
import { EditingHelpText } from 'helpers/Editing/EditingHelpText';
import { TextProps } from '@sitecore-content-sdk/react/types/components/Text';

interface PlainTextWrapperProps extends TextProps, React.HTMLAttributes<HTMLHeadingElement> {
  fallbacks?: (TextField | undefined)[];
}

const PlainTextWrapper = ({
  field,
  fallbacks,
  editable = true,
  ...props
}: PlainTextWrapperProps): JSX.Element => {
  const isEditing = useIsEditing() && editable;

  const { renderField, fallbackFieldForEditing } = useFieldWithFallbacks(field, fallbacks);

  const hasValue = !!renderField?.value;

  // We should only render if it has a value, or if we are editing
  const shouldRender = hasValue || isEditing;

  if (!shouldRender) return <></>;

  if (isEditing && fallbackFieldForEditing && fallbackFieldForEditing !== renderField) {
    return (
      <span>
        <Text
          {...props}
          data-component="helpers/fieldwrappers/plaintextwrapper"
          editable={editable}
          field={renderField}
        />

        <EditingHelpText>
          Fallback:
          <Text
            {...props}
            className={props.className}
            data-component="helpers/fieldwrappers/plaintextwrapper"
            editable={false}
            field={fallbackFieldForEditing}
          />
        </EditingHelpText>
      </span>
    );
  }
  return (
    <Text
      {...props}
      className={props.className}
      data-component="helpers/fieldwrappers/plaintextwrapper"
      editable={editable}
      field={renderField}
    />
  );
};

export default PlainTextWrapper;
